var common = require("../../utiles/common");
var layUtils = require("../../utiles/layUtils");
var metaTypeUtils = require("../../utiles/metaTypeUtils");
var metaService = require("../../services/metaService");

module.exports = {
    register: function () {
        document.createElement('b-form')
        ko.components.register('b-form', {
            viewModel: function (params) {
                var $this = this;
                $this.formId = params.formId ? params.formId : "userForm";
                $this.submitId = params.submitId ? params.submitId : "userInfo";
                $this.params = params.form;
                console.log(params)
                $this.fields = ko.observableArray($this.params.fields ? $this.params.fields : []);


                $this.selectChange = function(data){
                    console.log(data)

                    // if($this.params.selectBack){
                    //     $this.fields($this.params.selectBack($this.params.fields));
                    // }
                }

                $this.refresh = function(){
                    setTimeout(function(){
                        var attrs = params.attrs?params.attrs:[];
                        layUtils.formRender({
                            attrs:attrs,
                            data:$this.params.data,
                            callback:function(data){
                                if($this.params.callback){
                                    $this.params.callback(metaTypeUtils.coverFormData(data,attrs));
                                }
                            }
                        });
                    }, 1)
                }
                $this.refresh();
            },
            template: require("./BForm.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/form/BForm.js
// module id = 79
// module chunks = 0